import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component } from 'preact';
export class Carousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            images: []
        };
    }
    componentDidMount() {
        const imageStates = this.props.s3Objects.map(({ presignGetUrl }, index) => {
            return {
                url: presignGetUrl,
                selected: index === 0
            };
        });
        this.setState({
            images: imageStates
        });
    }
    render() {
        const images = this.state.images;
        return (_jsxs("div", Object.assign({ class: "carousel" }, { children: [_jsx("ul", Object.assign({ class: "slider" }, { children: images.map(m => (_jsx("li", Object.assign({ class: `${m.selected === true ? 'show' : ''}` }, { children: _jsx("img", { src: m.url }, void 0) }), void 0))) }), void 0),
                _jsx("ul", Object.assign({ class: "thumbnail" }, { children: images.map((m, index) => (_jsx("li", Object.assign({ class: `${m.selected === true ? 'selected' : ''}`, onClick: _ => { this.handleStepIntoSlide(index); } }, { children: _jsx("img", { src: m.url }, void 0) }), void 0))) }), void 0)] }), void 0));
    }
    handleSlidePrevuios() {
        const images = this.state.images;
        const current = images.filter(p => p.selected === true)[0];
        const currentIndex = images.indexOf(current);
        if (currentIndex > 0) {
            const next = images.map((m, index) => {
                m.selected = index === (currentIndex - 1);
                return m;
            });
            this.setState({
                images: next
            });
        }
    }
    handleSlideNext() {
        const images = this.state.images;
        const current = images.filter(p => p.selected === true)[0];
        const currentIndex = images.indexOf(current);
        if (currentIndex < (images.length - 1)) {
            const next = images.map((m, index) => {
                m.selected = index === (currentIndex + 1);
                return m;
            });
            this.setState({
                images: next
            });
        }
    }
    handleStepIntoSlide(nextIndex) {
        const next = this.state.images.map((m, index) => {
            m.selected = index === nextIndex;
            return m;
        });
        this.setState({
            images: next
        });
    }
}
